<script setup lang="ts">
interface Props {
  width?: number;
  height?: number;
}

withDefaults(defineProps<Props>(), {
  width: 24,
  height: 24,
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="48"
      height="48"
      rx="12"
      fill="var(--brand-vk)"
    />
    <path
      fill="var(--brand-glyph)"
      d="M25.54 34.58c-10.94 0-17.18-7.5-17.44-19.98h5.48c.18 9.16 4.22 13.04 7.42 13.84V14.6h5.16v7.9c3.16-.34 6.48-3.94 7.6-7.9h5.16c-.86 5.04-4.46 8.64-7.02 10.12 2.56 1.2 6.66 4.34 8.22 9.86h-5.68c-1.22-3.8-4.26-6.74-8.28-7.14v7.14z"
    />
  </svg>
</template>
